import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Card, CardBody, CardHeader, Col, DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { getPersonalProtectiveEquipmentList } from '../../../../slices/thunks';
import OPlaceholder from '../../../../Components/OElements/OPlaceholder';

const LatestAssignments = ({ title, establishment_id = null, limit = 10 }) => {
    const dispatch = useDispatch();
    const [selectedFilter, setSelectedFilter] = useState('1M');

    const [chartData, setChartData] = useState({ series: [], categories: [], fuelSummary: [] });

    const selectorPersonalProtectiveEquipment = createSelector(
        state => state.PersonalProtectiveEquipments,
        data => ({
            isLoading: data.isLoadingList,
            itemPersonalProtectiveEquipmentList: data.itemPersonalProtectiveEquipmentList,
        })
    );

    const { isLoading, itemPersonalProtectiveEquipmentList } = useSelector(selectorPersonalProtectiveEquipment);


    useEffect(() => {
        dispatch(getPersonalProtectiveEquipmentList({ 'sort_field': 'assignment_date', limit: limit, 'establishment_id': establishment_id }));
    }, []);

    const handleFilterChange = (filter) => {
        setSelectedFilter(filter);
        dispatch(getPersonalProtectiveEquipmentList({ 'sort_field': 'assignment_date', limit: limit, 'establishment_id': establishment_id }));
    };

    if (isLoading) {
        return <OPlaceholder />;
    }


    return (
        <Card className='h-100 p-0 m-0'>
            <CardHeader className='p-2 align-items-center d-flex'>
                <h5 className="flex-grow-1 m-0">{title}</h5>
            </CardHeader>
            <CardBody>
                <div className="table-responsive table-card">
                    <table className="table table-sm table-striped table-hover table-borderless table-nowrap table-centered align-middle mb-0">
                        <thead className="table-light text-muted">
                            <tr>
                                <th scope="col">Nombre</th>
                                <th scope="col">Fecha</th>
                                <th scope="col">Estado</th>
                                <th scope="col">Código</th>
                                <th scope="col">Establecimiento</th>
                            </tr>
                        </thead>
                        <tbody>
                            {(itemPersonalProtectiveEquipmentList || []).map((item, key) => (<tr key={key}>
                                <td className="text-muted fs-11">{item.person?.name}</td>
                                <td className="text-muted fs-11">
                                    {(() => {
                                        const statusCode = item.personal_protective_equipment_status.code;
                                        if (['END', 'AGD', 'CND', 'RTD'].includes(statusCode)) {
                                            return item.assignment_date ? new Date(item.assignment_date).toLocaleDateString('es-CL') : '';
                                        } else if (statusCode === 'DVT') {
                                            return item.return_date ? new Date(item.return_date).toLocaleDateString('es-CL') : '';
                                        } else if (statusCode === 'RPD') {
                                            return item.receive_date ? new Date(item.receive_date).toLocaleDateString('es-CL') : '';
                                        } else {
                                            return '';
                                        }
                                    })()}
                                </td>
                                <td><span className={`badge fs-11`} style={{ backgroundColor: item.personal_protective_equipment_status.bgcolor, color: item.personal_protective_equipment_status.txcolor }}>{item.personal_protective_equipment_status.name}</span></td>
                                <td className="text-muted fs-8">{item.code}</td>
                                <td className="text-muted fs-11">{item.establishment.name}</td>
                            </tr>))}
                        </tbody>
                    </table>
                </div>
                <div className="mt-3 text-center">
                    <Link to="/supply/ppe" className="text-muted text-decoration-underline">Ver todas</Link>
                </div>
            </CardBody>
        </Card>
    );
};

export default LatestAssignments;